module.exports = __webpack_public_path__ + "static/app-screen-1-bd7cb079aa9b1655756132aea2695634.png";